import {
  Form,
  useActionData,
  useLoaderData,
  useSearchParams,
} from "react-router-dom";

import Resolver from "@/components/resolver";

import { Button } from "@/components/clickable";
import { TextField } from "@/components/forms";
import { HStack, VStack } from "@/components/layout";
import { PlanSelector } from "@/modules/billing";
import Informations from "../informations";

export default function CreateAccountView() {
  const { prices } = useLoaderData();
  let [searchParams] = useSearchParams();

  const data = useActionData();
  const errors = data?.formErrors;
  const name = searchParams.get("name");

  return (
    <HStack className="text-cp-body relative isolate min-h-svh w-full items-center justify-center gap-[10rem] p-8 max-lg:flex-col lg:bg-zinc-100">
      <Informations />
      <Form method="post">
        <VStack className="border-cp-grey-300 max-w-lg gap-4 rounded-md border bg-white p-10 shadow-lg md:overflow-y-auto lg:max-h-[35.8rem] 2xl:max-h-[48.8rem] 2xl:overflow-y-hidden">
          <p className="text-lg font-medium text-black">
            Create your CounselPro account
          </p>

          <Resolver resolve={prices}>
            <PlanSelector />
          </Resolver>

          <TextField
            name="name"
            defaultValue={name}
            error={errors?.name}
            label="Law firm name"
            placeholder="Type the name of your firm"
            description="This name will appear on your dashboard and in billing correspondence."
          />

          <Button className="w-full" type="submit">
            Create Account
          </Button>
        </VStack>
      </Form>
    </HStack>
  );
}
